<!-- 产业政策 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="pageInfoBlock" title="产业政策" label="INFORMARION" :tabList="tabList" :tabDefaultType="tabDefaultType"  count="20" v-on:queryPage="cyzc_Req" v-on:clickTab="chooseTab"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="热门解读" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage3" v-on:queryPage="rmjd_Req" titleLength="18" count="8"/>
        <infoList title="推荐政策" label="INFORMARION" :showTitle="true" :showMore="false" :infoBlock="infoBlock3" :infoPage="infoPage4" v-on:queryPage="tjzc_Req" titleLength="18" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import InfoBlock04 from '../block/InfoBlock04'
import InfoList from '../block/InfoList'
import TitleInfoBlock01 from '../block/TitleInfoBlock01'
export default {
  name: 'Hyzx03',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList': InfoList,
  },
  data() {
    return {
      msg: '',
      pageInfoBlock:InfoBlock04,
      infoPage:{},
      infoBlock3:TitleInfoBlock01,
      infoPage3:{},
      infoPage4:{},
      tabList:[{title:"产业政策",type:'policy_library'},{title:"政策解读",type:'policy_analysis'}],
      tabDefaultType:'policy_library',
    }
  },
  methods:{
    chooseTab:function(tabType){
      //this.selectedItem=clickedItem.title
      console.log("------回调成功"+tabType);
      this.cyzc_Req({pageSize:7,page:1,type:tabType});
    },
    //产业政策、解读
    cyzc_Req(params){
          let that=this;
          let result={page:params};
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.articleList(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
    //热门解读
    rmjd_Req(params){
        let that=this;
        params.type='policy_analysis';
        let result={page:params};
        console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
        that.$dataApi.articleList(params).then(res =>{
        //console.log('请求Vue-axios结果：'+JSON.stringify(res))
        that.msg=res.msg;
        result.list= res.data.list;
        result.page.total=res.data.total;
        that.infoPage3=result;
        //console.log('结束请求Vue-axios：'+JSON.stringify(result))
        });
    },
    //推荐政策
    tjzc_Req(params){
          let that=this;
          params.type='policy_library';
          let result={page:params};
          console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
          that.$dataApi.articleList(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage4=result;
          //console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
  created:function(){
    let params={page:1,pageSize:7,type:this.tabDefaultType};
    this.cyzc_Req(params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Hyzx03.vue